import { writable } from 'svelte/store'
import moment from 'moment';
import 'moment/locale/es';

function getTree(){
    let tree = {
        label: "Capas", 
        titletree: true,
        children: [
            {
                label: "Puntos de calor por formación vegetal", 
                group: 'pcalor', 
                title: true,
                children: []
            }
        ]
    };
    const startYear = 2017;
    const endYear = moment().year();
    for (let year = startYear; year <= endYear; year++) {
    const yearNode = {
        id: year,
        label: year.toString(),
        annio: year.toString(),
        group: 'pcalor',
        children: []
    };
    
    if (year !== endYear) {
        for (let month = 0; month < 12; month++) {
            const currentMonth = year === endYear ? moment().month() : 11;
            const monthNode = {
                id: 40,
                label: `${moment().month(month).format("MMMM").charAt(0).toUpperCase()}${moment().month(month).format("MMMM").slice(1)}`,
                layer: `pcalor${moment().month(month).format("MM")}_${year}h`,
                name: `P.Calor ${moment().month(month).format("MM")}/${year}`,
                annio: year.toString(),
                selected: false,
                group: 'pcalor'
            };
            yearNode.children.push(monthNode);
            yearNode.children.sort((a, b) => b.id - a.id);
        }
    } else {
        for (let month = moment().month(); month >= 0; month--) {
            const monthNode = {
                id: 40,
                label: `${moment().month(month).format("MMMM").charAt(0).toUpperCase()}${moment().month(month).format("MMMM").slice(1)}`,
                layer: `pcalor${moment().month(month).format("MM")}_${year}h`,
                name: `P.Calor ${moment().month(month).format("MM")}/${year}`,
                annio: year.toString(),
                selected: false,
                group: 'pcalor'
            };
            yearNode.children.push(monthNode);
            yearNode.children.sort((a, b) => b.id - a.id);
        }
    }
    
    tree.children[0].children.push(yearNode);
    tree.children[0].children.sort((a, b) => b.id - a.id);
    }
    let qmodisTree =        {
        label: "Áreas quemadas MODIS",group:'aquemadas',title:true,
        children: [
            {
                label: "2024", annio:'2024',group:'aquemadas',children:
                [
                    
                    { id:41,label: "Marzo", layer: 'modish03_2024', annio:'2024', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2024', annio:'2024', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2024', annio:'2024', selected: false,outline:true,group:'aquemadas' }
                ]
            },
            {
                label: "2023", annio:'2023',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2023', annio:'2023', selected: false,outline:true,group:'aquemadas' }
                ]
            },
            {
                label: "2022", annio:'2022',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2022', annio:'2022', selected: false,outline:true,group:'aquemadas' }
                ]
            },
            {
                label: "2021", annio:'2021',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2021', annio:'2021', selected: false,outline:true,group:'aquemadas' }
                ]
            },
            {
                label: "2020", annio:'2020',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2020', annio:'2020', selected: false,outline:true,group:'aquemadas' }
                ]
            },
            {
                label: "2019", annio:'2019',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2019', annio:'2019', selected: false,outline:true,group:'aquemadas' }

                ]
            },
            {
                label: "2018", annio:'2018',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2018h', annio:'2018', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2018h', annio:'2021', selected: false,outline:true,group:'aquemadas' }
                ]
            },
            {
                label: "2017", annio:'2017',group:'aquemadas',children:
                [
                    { id:41,label: "Diciembre", layer: 'modish12_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Noviembre", layer: 'modish11_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Octubre", layer: 'modish10_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Septiembre", layer: 'modish09_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Agosto", layer: 'modish08_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Julio", layer: 'modish07_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Junio", layer: 'modish06_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Mayo", layer: 'modish05_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Abril", layer: 'modish04_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Marzo", layer: 'modish03_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Febrero", layer: 'modish02_2017h', annio:'2017', selected: false,outline:true,group:'aquemadas' },
                    { id:41,label: "Enero", layer: 'modish01_2017h', annio:'2021', selected: false,outline:true,group:'aquemadas' }
                ]
            }
        ]
    }
    tree.children.push(qmodisTree)
    console.log(tree)
    return tree
}
export const treeTools = writable([
    {
        id: '',
        label: ``,
        layer: ``,
        name: ``,
        annio: ``,
        selected: false,
        group: 'pcalor'
    }
])

export const treeConfig = writable([getTree()])
